module.exports = __webpack_public_path__ + "static/img/activity-20220509.2d86ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20220509.png
// module id = Gsh3
// module chunks = 0